module.exports = __webpack_public_path__ + "assets/img/18_278_big.5d0ee8ba.jpg";